import { render } from "./ListPokokDoaView.vue?vue&type=template&id=872146a6"
import script from "./ListPokokDoaView.vue?vue&type=script&lang=js"
export * from "./ListPokokDoaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__